export default __webpack_public_path__ + "static/media/aeroic.a7a866f0.jpg";